<template>
  <div class="page-wrapper">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <success-modal
      :show="showSuccessPopup"
      @close="closeSuccessPopup"
      :msg="'You have successfully added the shipment.'"
      :heading="'Shipment Added!'"
    />

    <AddContainerModal
      :show="showAddContainer"
      :onCancel="closeAddContainer"
      @add-container="addContainer"
      @edit-container="updateEditContainer"
      v-if="showAddContainer"
      :containers="containers"
      :containerData="container"
      :devicesByStatus="devicesByStatus"
      :shipmentType="getShipmentType"
    />

    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-md-5 align-self-center mb-2">
          <h6 class="font-16 font-weight-bold">
            {{ $t("add-shipment") }}
          </h6>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="card">
        <div class="card-body add-dispatch-container">
          <div class="mb-3">
            <Stepper class="custom-page" :step="step" :labels="labels" />
          </div>
          <div class="d-flex align-items-center justify-content-between mb-4">
            <p class="font-bold">
              {{ currentStep }}
            </p>
            <div
              class="shipment-type"
              @click="showShipmentType = true"
              v-if="step === 1"
            >
              <span class="shipment-type-value"
                >{{ getShipmentType }} Freight</span
              >
              <IconDown />

              <div
                class="shipment-type-options"
                v-if="showShipmentType && step === 1"
                v-click-outside="closeShipmentType"
              >
                <div @click="chanegShipmentType('sea')">Sea Freight</div>
                <div @click="chanegShipmentType('air')">Air Freight</div>
              </div>
            </div>
            <div
              class="cursor-pointer d-flex justify-content-center align-items-center"
              @click="handleAddBtn"
              v-if="showAddBtn"
            >
              <icon-circle-add class="mr-2" />
              <span class="text-primary text-capitalize">
                {{ step === 2 ? $t("add_container") : null }}
              </span>
            </div>
          </div>
          <ShipmentDetailsStep
            v-if="step === 1"
            ref="ShipmentDetailsStep"
            :shipmentDetailss="shipmentDetails"
          />
          <ContainerDetails
            @showAddContainerModal="openAddContainer"
            :containers="containers"
            @edit_container="editContainer"
            @delete_container="deleteContainer"
            v-if="step === 2"
          />
          <OriginDestinationStep
            v-if="step === 3"
            ref="originDestinationStep"
            :originProp="origin"
            :destinationProp="destination"
            :shipmentDetails="shipmentDetails"
          />
          <Summary
            v-if="step === 4"
            @goToStep="goToStep"
            :origin="origin"
            :destination="destination"
            :shipmentDetails="shipmentDetails"
            :containers="containers"
            @delete_containerDetails="deleteContainer"
          />
          <div
            class="d-flex align-items-start justify-content-end col-gap-1 pt-4"
          >
            <button class="btn btn-secondary text-capitalize" @click="goBack">
              {{ $t("back_") }}
            </button>

            <button @click="goNext" class="btn btn-primary">
              {{ step === 4 ? $t("done") : $t("next") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Stepper from "../../../components/Stepper.vue";
import OriginDestinationStep from "./OriginDestinationStep.vue";
import ContainerDetails from "./ContainerDetails.vue";
import ShipmentDetailsStep from "./ShipmentDetailsStep.vue";
import Summary from "./Summary.vue";
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SuccessModal from "../../Modals/SuccessModal.vue";
import IconDown from "../../../components/Iconsvg/IconDown.vue";

import AddContainerModal from "../../Modals/AddContainerModal.vue";
import vClickOutside from "v-click-outside";

import IconCircleAdd from "../../../components/Iconsvg/IconCircleAdd.vue";

import loadGoogleMapsApi from "load-google-maps-api";

export default {
  name: "AddShipment",
  components: {
    Stepper,
    ShipmentDetailsStep,
    OriginDestinationStep,
    Summary,
    Loading,
    SuccessModal,
    ContainerDetails,
    AddContainerModal,
    IconCircleAdd,
    IconDown,
  },

  directives: {
    clickOutside: vClickOutside.directive,
  },

  data() {
    return {
      step: 1,
      labels: ["Shipment", "Container", "Origin/Destination", "Summary"],
      origin: {},
      destination: {},
      shipmentDetails: {},
      isLoading: false,
      showSuccessPopup: false,
      fullPage: true,
      showAddContainer: false,
      showShipmentType: false,
      containers: [],
      container: {},
      isSchedule: false,
      scheduleReport: "",
      notifyUsers: null,
    };
  },
  computed: {
    ...mapGetters(["devicesByStatus", "getShipmentType"]),

    showAddItemBtn() {
      return this.step === 2 && this.containers.length > 0;
    },
    showAddBtn() {
      return this.showAddItemBtn;
    },
    currentStep() {
      let stepTitle = "";
      switch (this.step) {
        case 2:
          stepTitle = "Container";
          break;
        case 3:
          stepTitle = "Origin/Destination";
          break;
        case 4:
          stepTitle = "Summary";
          break;
        default:
          stepTitle = "Shipment Details";
          break;
      }
      return stepTitle;
    },
  },

  methods: {
    ...mapActions([
      "getOrigin",
      "getDestinations",
      "addShipment",
      "fetchallDevices",
      "getDevicesByStatus",
      "updateShipmentType",
      "getUsers",
    ]),

    closeShipmentType() {
      this.showShipmentType = false;
    },

    handleAddBtn() {
      if (this.showAddItemBtn) {
        this.openAddContainer();
      }
    },
    chanegShipmentType(value) {
      this.updateShipmentType(value);
      this.showShipmentType = false;
    },
    openAddContainer() {
      this.showAddContainer = true;
      this.container = {};
    },
    closeAddContainer() {
      this.showAddContainer = false;
      this.id = null;
      this.container = {};
    },
    addContainer(container) {
      const id = this.containers.length + 1;
      this.container = { ...container, id };

      this.showAddContainer = false;
      this.id = id;
      this.containers.push({ ...container, id });

      console.log("container:", this.containers, "id", id);
    },
    editContainer(container) {
      this.showAddContainer = true;
      this.container = { ...this.container, ...container };
    },
    deleteContainer(index) {
      this.containers.splice(index, 1);
      console.log("deleted");
    },
    updateEditContainer(container) {
      console.log("Original container:", this.container);
      this.container = { ...this.container, ...container };
      console.log("Updated container:", this.container);

      console.log("Container ID to update:", this.container.id);
      console.log(
        "All container IDs:",
        this.containers.map((c) => c.id)
      );

      const index = this.containers.findIndex(
        (c) => c.id === this.container.id
      );

      if (index !== -1) {
        this.$set(this.containers, index, {
          ...this.containers[index],
          ...container,
        });
        console.log("Updated containers array:", this.containers);
      }

      this.showAddContainer = false;
    },
    goNext() {
      if (this.step === 1) {
        const isValid = this.$refs.ShipmentDetailsStep.validateForm();
        if (isValid) {
          this.shipmentDetails = this.$refs.ShipmentDetailsStep.getFormData();
          this.step++;
        }
        return;
      }
      if (this.step === 2 && this.containers.length >= 1) {
        this.step++;
        return;
      }
      if (this.step === 3) {
        const isValid = this.$refs.originDestinationStep.validateForm();
        if (isValid) {
          const { origin, destination, isScheduledReport, schedule, notify } =
            this.$refs.originDestinationStep.getFormData();
          this.scheduleReport = schedule;
          this.isSchedule = isScheduledReport;

          this.origin = origin;
          this.destination = destination;
          this.notifyUsers = notify;
          this.step++;
        }
        return;
      }
      if (this.step === 4) {
        const payload = {
          ...this.shipmentDetails,
          schedule: this.scheduleReport,
          isScheduledReport: this.isSchedule,
          notify: this.notifyUsers
            ? {
                emailUsers: this.notifyUsers.map((val) => val.id),
              }
            : undefined,
          containers: this.containers.map((container) => ({
            pallet: container.pallet,
            product: container.product,
            containerNumber: container.containerNumber,
            assignedDevices: container.assignedDevices.map(
              (device) => device.id
            ),
          })),

          origin: this.origin.id ? this.origin.id : undefined,
          originInfo: !this.origin.id ? this.origin : undefined,

          destination: this.destination.id ? this.destination.id : undefined,
          destinationInfo: !this.destination.id ? this.destination : undefined,

          pointOfArrivalPoint:
            !this.destination.id &&
            this.shipmentDetails.lat &&
            this.shipmentDetails.lng
              ? {
                  lat: this.shipmentDetails.lat,
                  lng: this.shipmentDetails.lng,
                }
              : undefined,
        };
        this.isLoading = true;
        this.addShipment(payload)
          .then(() => {
            this.isLoading = false;
            this.showSuccessPopup = true;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },

    goBack() {
      if (this.step === 3) {
        const { origin, destination } =
          this.$refs.originDestinationStep.getFormData();
        this.origin = origin;
        this.destination = destination;
        return this.step--;
      }
      if (this.step > 1) {
        this.step--;
      } else {
        this.$router.push("/export/dispatch");
      }
    },
    goToStep(step) {
      this.step = step;
    },
    closeSuccessPopup() {
      this.showSuccessPopup = false;
      this.$router.push("/export/dispatch");
    },
  },
  mounted() {
    this.getDevicesByStatus({ status: "ongoing" });

    this.getOrigin();
    this.getDestinations();
    this.fetchallDevices();
    this.getUsers();

    loadGoogleMapsApi({
      key: process.env.VUE_APP_GOOGLE_API_KEY,
      libraries: ["places", "drawing", "geometry"],
    });
  },
};
</script>

<style scoped>
@media (min-width: 540px) {
  .custom-page >>> .stepper p:nth-child(2) {
    margin-left: 2rem;
  }
}

.page-wrapper > .container-fluid {
  margin-top: 0;
}

.card-body {
  padding: 2rem;
}
.shipment-type {
  border: 1px solid #b7c3cd;
  padding: 16px;
  width: 165px;
  border-radius: 8px;
  cursor: pointer;
  color: #404a57;
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
}

.shipment-type-options {
  position: absolute;
  width: 100%;
  top: 102%;
  z-index: 2;
  left: 0;
  right: 0;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0px 4px 16px 0px #00000014;
  padding: 16px;
  display: grid;
  justify-content: center;
  gap: 8px;
}
.shipment-type-options div {
  height: 40px;
}

.shipment-type-value {
  text-transform: capitalize;
}
</style>
